import { Injectable } from '@angular/core';
import { GlobalSyncInstitution } from '@models/mortgages/closer-sync-institutions';
import { State } from '@ngxs/store';
import { CollectionPaths } from '@models/collections';
import {
	GlobalStateModel,
	FirestoreStateBaseForGlobalWithSubscription,
} from '@state/FirestoreStateBaseForGlobal';
import { DEFAULT_STATE_BASE } from '@state/FirestoreStateBase';

export interface GlobalSyncInstitutionsStateModel extends GlobalStateModel {
	data: GlobalSyncInstitution[];
}

const DEFAULT_STATE: GlobalSyncInstitutionsStateModel = {
	...DEFAULT_STATE_BASE,
	data: [],
};

@State<GlobalSyncInstitutionsStateModel>({
	name: 'globalSyncInstitutions',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class GlobalSyncInstitutionsState extends FirestoreStateBaseForGlobalWithSubscription<
	GlobalSyncInstitution,
	GlobalSyncInstitutionsStateModel
> {
	constructor() {
		super(
			() => CollectionPaths.closerSyncFinancialInstitutions(),
			(payload) => ({ data: payload as GlobalSyncInstitution[] }),
			() => DEFAULT_STATE,
		);
	}
}
